import React, { Suspense, lazy } from 'react';
import { Link, withRouter } from "react-router-dom";
import { Login } from './login';
import { IMG_LOGO, COMPANY_NAME_FULL, GET_PARENT } from '../../common';
import PageContext from '../../context';
import { Amplify, Auth, Hub } from 'aws-amplify';
import { AWS_COGNITO_LOGIN_POOL, HEADER_BLOCK_ID } from '../../common/constant';
import { profile } from '../../jwt/_services/profile-service';
import { EnrollService } from '../../jwt/_services/enrollment-service';
import Pool from '../../aws-pool/login-pool';
import { authContext } from '../../data/authContext';

const ImageLoader = lazy(() => import('../../common/image-loader'));

let pathName = '';
let navbarToggler = null;
const mobileView = 1024;

// Amplify.configure({
// 	Auth: {
// 		userPoolId: AWS_COGNITO_LOGIN_POOL.USER_POOL_ID,
// 		userPoolWebClientId: AWS_COGNITO_LOGIN_POOL.CLIENT_ID,
// 		region: AWS_COGNITO_LOGIN_POOL.AWS_REGION,
// 		scope: ['phone', 'openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
// 		oauth: {
// 			domain: AWS_COGNITO_LOGIN_POOL.OAUTH_DOMAIN,
// 			redirectSignIn: String(window.location.origin),
// 			redirectSignOut: String(window.location.origin),
// 			// redirectSignIn: String(window.location.origin + window.location.pathname),
// 			// redirectSignOut: String(window.location.origin + window.location.pathname),
// 			responseType: 'token'
// 		}
// 	}
// })

class Header extends React.Component {
	static contextType = PageContext;
	static authContext = authContext;
	constructor(props) {
		super(props);
		this.setupAuthListners() 
		this.state = {
			filter: [],
			headerMenu: [
				{ "id": 1, "name": "Home", "naveLink": '/home', redirect: false },
				{ "id": 2, "name": "Campaigns", "naveLink": '/campaigns', redirect: false },
				{ "id": 3, "name": "Contact", "naveLink": '/contact', redirect: false }
			],
			isHeaderMenu: false,
			isLogoVisible: false,
			logoUrl: '',
			isLoginEnable: false,
			isScrolling: false,
			toggleNav: false,
			profileName: '',
			federatedSignIn: null,
			isUnauthorized: localStorage.getItem('unAuthorizedAcc') !== null ? true : false,
			isPreRegistered: localStorage.getItem('preRegistered') !== null ? true : false,
			socialMediaIcon: null,

		}		

		this.navLinkRef = React.createRef();

		this.navLinkClick = this.navLinkClick.bind(this);
		this.scrollSpy = this.scrollSpy.bind(this);
		this.toggleNAV = this.toggleNAV.bind(this);
		this.onResizeHeaderReset = this.onResizeHeaderReset.bind(this);
		this.updateProfileName = this.updateProfileName.bind(this);
		this.handlePopupIsOpen = this.handlePopupIsOpen.bind(this);
		this.setAuthorizedSocial = this.setAuthorizedSocial.bind(this);
	}

	toggleNAV() {
		this.setState({ toggleNav: !this.state.toggleNav });
	}

	navLinkClick(e, link) {
		if (link.redirect) {
			e.preventDefault()
			window.open(link.naveLink, "_blank")
			return;
		}

		this.setState({ isScrolling: true });
		let ele = e.target;
		let parent = GET_PARENT(ele, 'UL');
		let header = document.querySelector('header')?.offsetHeight;
		pathName = ele.innerText.trim().replaceAll(".", "").replaceAll(' ', '-').toUpperCase();
		let locPathName = this.props.history.location.pathname;
		let destination = document.getElementById(pathName);
		let PaymentContext = this.context.PaymentContext;
		PaymentContext.donationMethod = 'cause';

		if (destination) {
			e.preventDefault();
			PaymentContext.referrer = pathName;
			PaymentContext.scrollTo(pathName ?? 0);
		} else {
			PaymentContext.referrer = pathName;
		}
		this.onResizeHeaderReset();
		setTimeout(() => {
			this.setState({ isScrolling: false });
		}, 300);
	}

	scrollSpy(e) {
		let PaymentContext = this.context.PaymentContext;
		//if (PaymentContext.referrer) { PaymentContext.referrer = '';}
		if (!this.state.isScrolling) {
			this.setState({ isScrolling: true });
			setTimeout(() => {
				let ele = null;
				let list = [];

				this.state.headerMenu && this.state.headerMenu.forEach(item => {
					let ele = document.getElementById(item.name.replace(/\s+/gim, '-').replace(/\./gim, '').toUpperCase());
					if (ele) {
						if ((ele.offsetTop - 280) <= document.body.scrollTop) {
							list.push(item.name);
						}
					}
				});
				this.setState({ isScrolling: false });
				//console.log('list--', list);
				if (pathName != 'CONTACT') {
					PaymentContext.setNavActiveInactive(list[list.length - 1], pathName);
				} else {
					pathName = '';
				}
				list = [];
			}, 500);
		}
	}

	configureHeader(headerData) {
		headerData.settings.map((data) => {
			switch (data.settingId) {
				case 1:
					this.setState({
						isLogoVisible: data.isVisible,
						logoUrl: data.settingValue    // logo icon should come from BE
					})
					break;
				case 2:
					this.setState({
						isHeaderMenu: data.isVisible,
						headerMenu: [
							{ "id": 1, "name": "Home", "naveLink": '/home', redirect: false },
							{ "id": 2, "name": "Campaigns", "naveLink": '/campaigns', redirect: false }, 
							{ "id": 3, "name": "Contact", "naveLink": '/contact', redirect: false }
						],
						logoUrl: data.settingValue
					});
					break;
				case 3:
					this.setState({
						isLoginEnable: data.isVisible
					})
					break;
				default:
					break;
			}
		})
	}

	onResizeHeaderReset(isResize) {
		const navbarToggler = document.querySelector('header .navbar-toggler');
		const navbarTogglerHidden = (window.getComputedStyle(navbarToggler)?.display === 'none') ?? navbarToggler.currentStyle?.display === 'none';

		if (this.state.isUnauthorized || this.state.isPreRegistered) {
			this.setState({ toggleNav: true });
			return;
		}
		if (window.innerWidth > mobileView) {
			this.setState({ toggleNav: true });
			return;
			//window.addEventListener('resize', this.onResizeHeaderReset);
		} else {
			if (!isResize) {
				this.setState({ toggleNav: false });
				/* if (navbarToggler && navbarTogglerHidden) {
					this.setState({ toggleNav: true });
					window.removeEventListener('resize', this.onResizeHeaderReset);
				} else {
					this.setState({ toggleNav: false });
					window.addEventListener('resize', this.onResizeHeaderReset);
				} */
			} else {
				if (this.state.isPopupOpen) {
					this.setState({ toggleNav: true });
				} else {
					this.setState({ toggleNav: false });
				}
				//this.setState({ toggleNav: !this.state.toggleNav });
				//window.removeEventListener('resize', this.onResizeHeaderReset);
			}
		}
	}

	setAuthorizedSocial() {
		localStorage.removeItem('unAuthorizedAcc');
		localStorage.removeItem('preRegistered');
		this.setState({ isUnauthorized: false, isPreRegistered: false })
	}

	handlePopupIsOpen(val) {
		this.setState({ isPopupOpen: val });
	}

	updateProfileName(name) {
		this.setState({ profileName: name });
	}

	setupAuthListners = () => {
		// Hub.listen needs to be setup before Amplify.configure
		Hub.listen("auth", ({ payload: { event, data } }) => {
			switch (event) {
				case "signIn":
					console.log('hub signin')
					break;
				case "signOut":
					this.setState({ federatedSignIn: null });
					console.log('hub signout')
					break;
				case "customOAuthState":
					console.log('hub customOAuth')
					break;
				case "signIn_failure":
					const d = decodeURI(data)
					const reg = /attributes.+required.+email./gi
					if(reg.test(d)) {
						console.log('Email missing on FB Account. Please use another account')
					}
					console.log('hub signin failed', data, d , typeof d, reg.test(d) )
					break;
				default:
					break;
			}
		});

		Amplify.configure({
			Auth: {
				userPoolId: AWS_COGNITO_LOGIN_POOL.USER_POOL_ID,
				userPoolWebClientId: AWS_COGNITO_LOGIN_POOL.CLIENT_ID,
				region: AWS_COGNITO_LOGIN_POOL.AWS_REGION,
				scope: ['phone', 'openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
				oauth: {
					domain: AWS_COGNITO_LOGIN_POOL.OAUTH_DOMAIN,
					redirectSignIn: String(window.location.origin),
					redirectSignOut: String(window.location.origin),
					// redirectSignIn: String(window.location.origin + window.location.pathname),
					// redirectSignOut: String(window.location.origin + window.location.pathname),
					responseType: 'token'
				}
			}
		})
	}

	componentDidMount() {
		navbarToggler = document.querySelector('header .navbar-toggler');

		// Hub.listen("auth", ({ payload: { event, data } }) => {
		// 	switch (event) {
		// 		case "signIn":
		// 			console.log('hub signin')
		// 			break;
		// 		case "signOut":
		// 			this.setState({ federatedSignIn: null });
		// 			console.log('hub signout')
		// 			break;
		// 		case "customOAuthState":
		// 			console.log('hub customOAuth')
		// 			break;
		// 		case "signIn_failure":
		// 			console.log('hub signin failed', data)
		// 			break;
		// 		default:
		// 			break;
		// 	}
		// });

		Auth.currentAuthenticatedUser()
			.then(currentUser => {
				// console.log('header 192', currentUser);
				// const isGoogleAcc = currentUser?.signInUserSession?.idToken?.payload?.identities[0].providerName === 'Google';
				// const isFBAcc = currentUser?.signInUserSession?.idToken?.payload?.identities[0].providerName === 'Facebook';

				// NULL safety to avoid application crash
				const userPayload = currentUser?.signInUserSession?.idToken?.payload
				const isGoogleAcc = userPayload?.identities && currentUser?.signInUserSession?.idToken?.payload?.identities[0].providerName === 'Google';
				const isFBAcc = userPayload?.identities && currentUser?.signInUserSession?.idToken?.payload?.identities[0].providerName === 'Facebook';


				const NRIC = localStorage.getItem('socialNRIC');

				const NRICattribute = currentUser?.attributes['custom:NRIC'];

				// Call checkCogntioAndCreateGPDonor with an email to check if account exists already.
				profile.checkCogntioAndCreateGPDonor({
					"emailId": currentUser?.signInUserSession?.idToken?.payload?.email,
					"name": currentUser?.signInUserSession?.idToken?.payload?.name ?? currentUser?.signInUserSession?.idToken?.payload?.given_name,
					"verifiedBy": "manual",
				}).then(response => {
						if (response.data?.isEmailExists && response.data?.accCount === 2) {
							localStorage.setItem('preRegistered', true);
							Auth.deleteUser();
						} else if (isGoogleAcc || isFBAcc) {
							this.setState({ federatedSignIn: currentUser }); // set federatedSignIn if isGoogleAcc or isFBAcc

							// Set Auth details in context
							authContext.isUserLoggedIn = true;
							authContext.userEmail = currentUser?.signInUserSession?.idToken?.payload?.email;
							authContext.userName = currentUser?.signInUserSession?.idToken?.payload?.name;
							authContext.guid = currentUser?.username;
							localStorage.setItem("isAuthenticated", true);
							localStorage.setItem("user_guid", authContext.guid)

							Auth.updateUserAttributes(currentUser, {
								// 'custom:BUSINESS_ACC': "No",
								'custom:NRIC': "",
								'email': currentUser?.signInUserSession?.idToken?.payload?.email,
								'name': currentUser?.signInUserSession?.idToken?.payload?.name ?? currentUser?.signInUserSession?.idToken?.payload?.given_name,
							})
								// .then(res => {
								//     EnrollService.registerCognitoUser({
								//         phoneCountryCode: '',
								//         phoneNumber: '',
								//         uniqueUserId: btoa(NRIC),
								//     }).then((res) => {
								//         if (res?.status !== 0) {
								//             localStorage.removeItem('socialNRIC');
								//         }
								//         this.setState({ isLoader: false });
								//     });
								// })
								.catch((err) => {
									console.log('Error', err);
									// localStorage.removeItem('socialNRIC');
								})
						} else {
							const countryCode = currentUser?.signInUserSession.idToken?.payload['custom:COUNTRY_CODE'] ?? '';
							let mobileNumber = currentUser?.signInUserSession.idToken?.payload.phone_number ?? '';
							const address = currentUser?.signInUserSession.idToken?.payload.address?.formatted
							const userData = { addressObj: {} };
						}

					})

			})
			.catch((err) => console.log("Not signed in", err));

		const user = Pool.getCurrentUser();
		// const { getSession } = this.context;

		user && this.props.ctx.getSession().then(data => {
			// console.log('session', data);
			authContext.userName = data.idToken.payload?.name ?? "";
			authContext.userEmail = data.idToken.payload?.email ?? "";
			this.setState({ profileName: Boolean(data.idToken.payload?.name) ? data.idToken.payload?.name : data.idToken.payload?.given_name })
		})

		// muis clone - LOGIN - END

		const context = this.context;
		context.PaymentContext.navLinkRef = this.navLinkRef;

		const settings = context.blockDetails.filter((block) => block.blockId === HEADER_BLOCK_ID)
		this.configureHeader(settings[0]);
		this.setState({
            socialMediaIcon: context.socialMediaIcon
        });
		this.onResizeHeaderReset();
		
		document.body.addEventListener('scroll', this.scrollSpy);
		window.addEventListener('resize', this.onResizeHeaderReset);
	}

	componentDidUpdate(prevProps, prevState) {
		let PaymentContext = this.context.PaymentContext;
		if (!PaymentContext.navLinkRef) {
			PaymentContext.navLinkRef = this.navLinkRef;
		}
		if (document.querySelector('.pre-loader')) {
			PaymentContext.scrollTo(0);
		}
	}

	componentWillUnmount() {
		document.body.removeEventListener('scroll', this.scrollSpy);
		window.removeEventListener('resize', this.onResizeHeaderReset);
	}

	render() {

		return (
			<header>
				<div className="container">
					{
						this.state.isLogoVisible && (
							<a href="https://artshouselimited.sg/" target="_blank" /* onClick={(e) => e.preventDefault()} */ className="navbar-brand" title={COMPANY_NAME_FULL}>
								<Suspense fallback={null}>
									<ImageLoader type="image" src={IMG_LOGO}></ImageLoader>
								</Suspense>
							</a>
						)
					}
					<button className="navbar-toggler" type="button" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={this.toggleNAV}>
						<span className={this.state.toggleNav ? "navbar-toggler-icon-close" : "navbar-toggler-icon"}></span>
					</button>

					<nav id="navbarSupportedContent" style={{ 'display': (this.state.toggleNav ? 'flex' : 'none'), justifyContent: "flex-end" }}>
						{
							this.state.isHeaderMenu && (
								<ul ref={this.navLinkRef} className="navbar-nav">
									{
										this.state?.headerMenu?.map((data, key) => {
											return (
												<li /* className={"nav-item " + (key === 0 ? 'active' : '')} */ key={key}>
													<Link to={'/'} className="nav-link" onClick={(e) => this.navLinkClick(e, data)}> {/* data.naveLink */}
														<span>{data.name.toUpperCase()}</span>
													</Link>
												</li>
											);
										})
									}
								</ul>
							)

						}

                         { (!this.state.isHeaderMenu && this.state.socialMediaIcon) ?
                            <div className="c-social">
                                {
                                    this.state.socialMediaIcon.map((social, index) => {
										console.log("/images/social/" + social.socialMediaIconName.replace(' ', '').toLowerCase() + ".svg" , 'sociall')
                                        return (
                                            <a href={social.socialMediaIconUrl} target="_blank" title={social.socialMediaIconName} key={index}>
                                                <Suspense fallback={null}>
                                                    <ImageLoader type="image" src={"/images/social/" + social.socialMediaIconName.replace(' ', '').toLowerCase() + ".svg"}></ImageLoader>
                                                </Suspense>
                                            </a>
                                        )
                                    })
                                }
                            </div>
                            :
                            null
                        }

						{
							this.state.isLoginEnable && (
								<div className="c-login">
									<Login
										isFederatedSignIn={this.state.federatedSignIn}
										socialSignOut={() => {
											Auth.signOut()
												.then(() => {

													window?.FB && window?.FB?.logout(function (response) {
														return true;
													})

													// this.props.dispatch(fidyahActions.reset());

												}).then(() => window.location.reload())
										}}
										name={this.state.profileName}
										updateName={this.updateProfileName}
										handlePopupIsOpen={this.handlePopupIsOpen}
										fbCall={() => Auth.federatedSignIn({ provider: 'Facebook' })}
										googleCall={() => Auth.federatedSignIn({ provider: 'Google' })}
										isUnauthorizedLogin={this.state.isUnauthorized}
										isPreRegistered={this.state.isPreRegistered}
										setAuthorizedSocial={this.setAuthorizedSocial}
									/>
								</div>
							)
						}
					</nav>
				</div>
			</header>
		)
	}
}

//Header.contextType = PaymentContext;
export default withRouter(Header);
